// Vuex store for Service Worker interactions

/*

  STATE

 */

const state = {
  // serviceWorkerAvailable: null,
  // firebaseOfflineAvailable: null,
  // offlineAvailable: null,
  notification: null,
  installPrompt: null,
  acceptedInstallPrompt: null,
};

/*

  GETTERS

 */

const getters = {
  // exampleGetter: state => { },
};

/*

  ACTIONS

 */

const actions = {
  showUpdateNotification({ dispatch }, { onClick }) {
    // console.log('in showUpdateNotification');
    const snack = {
      text: 'App update available',
      actionText: 'Refresh',
      handler: onClick,
      keepOpen: true,
    };
    dispatch('ui/updateSnack', snack, { root: true });
  },

  updateInstallPrompt({ commit, dispatch }, prompt) {
    console.log('updateInstallPrompt');
    commit('setInstallPrompt', prompt);
    if (prompt) {
      dispatch('showInstallNotification');
    } else {
      dispatch('clearNotification');
    }
  },

  showInstallPrompt({ state, commit, dispatch }) {
    console.log('showInstallPrompt');
    const { installPrompt } = state;
    installPrompt.prompt();
    dispatch('clearNotification');
    // Wait for the user to respond to the prompt
    installPrompt.userChoice.then(choiceResult => {
      if (choiceResult.outcome === 'accepted') {
        commit('setAcceptedInstallPrompt', true);
        // Handled in App.vue in case user clicks mini-bar
        // dispatch('analytics/acceptAddToHomeScreen', null, { root: true });
        console.log('User accepted the A2HS prompt');
      } else {
        commit('setAcceptedInstallPrompt', false);
        dispatch('analytics/declineAddToHomeScreen', null, { root: true });
        console.log('User dismissed the A2HS prompt');
      }
      dispatch('updateInstallPrompt', null);
    });
  },

  showInstallNotification({ commit, state }) {
    console.log('showInstallNotification');
    if (state.notification) {
      return;
    }

    const notification = {
      type: 'install',
      message: 'Add app to Home screen',
      actionText: 'Add app to Home screen',
      // confirmHandler: dispatch('showInstallPrompt'),
    };
    console.log('show notification', notification);
    setTimeout(() => {
      commit('setNotification', notification);
    }, 500);
  },

  // setServiceWorkerStatus({ commit, dispatch, state }, sw) {
  //   const fbOffline = state.firebaseOfflineAvailable;
  //   commit('setServiceWorkerAvailable', sw);
  //   if (fbOffline !== null) {
  //     const offline = fbOffline && sw;
  //     commit('setOfflineAvailable', offline);
  //     dispatch('analytics/setSWDimensions', { sw, offline });
  //     console.log('sw set offline', sw, offline);
  //   }
  // },

  // setfirebaseOfflineStatus({ commit, dispatch, state }, fbOffline) {
  //   const sw = state.serviceWorkerAvailable;
  //   commit('setFirebaseOfflineAvailable', fbOffline);
  //   if (sw !== null) {
  //     const offline = fbOffline && sw;
  //     commit('setOfflineAvailable', offline);
  //     dispatch('analytics/setSWDimensions', { sw, offline });
  //     console.log('fb set offline', sw, offline);
  //   }
  // },
};

/*

  MUTATIONS

 */

const mutations = {
  setNotification(state, notification) {
    state.notification = notification;
  },

  clearNotification(state) {
    state.notification = null;
  },

  setInstallPrompt(state, prompt) {
    state.installPrompt = prompt;
  },

  setAcceptedInstallPrompt(state, bool) {
    state.acceptedInstallPrompt = bool;
  },

  setServiceWorkerAvailable(state, bool) {
    state.serviceWorkerAvailable = bool;
  },

  setFirebaseOfflineAvailable(state, bool) {
    state.firebaseOfflineAvailable = bool;
  },

  setOfflineAvailable(state, bool) {
    state.offlineAvailable = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
